module.exports = __webpack_public_path__ + "img/Farmacologia_com_Calculo_de_Medicamentos.00944eb1.jpg";